















































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { eventBus } from "../../utils/event";
import ChangePass from "./ChangePass.vue";
import Lc from "@/plugins/loginCtl";

export default Vue.extend({
  name: "MyHeader",
  components: { ChangePass },
  computed: mapState("LoginInfo", ["userinfo"]),
  methods: {
    ...mapActions("LoginInfo", ["logout"]),
    toLogin() {
      this.logout().then(() => {
        Lc.logout();
      });
    },
    collapse() {
      eventBus.$emit("collapse");
    },
    handleCommand(key: string) {
      switch (key) {
        case "password":
          (this.$refs.ChangePass as any).show();
          break;

        case "exit":
          this.toLogin();
          break;
      }
    },
    toHelp() {
      window.open("/help/index.html", "_black");
    }
  }
});
